<template>
	<section class="v2rt">
		<div class="v2rt-card">
			<div class="v2rt-card__head">
				<div class="v2rt-card__icon v2rt-card__icon--purple">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
				</div>
				<div>
					<div class="v2rt-card__title">{{ $t('campaign.history_tab') | capitalize }}</div>
					<div class="v2rt-card__sub">Audit log of changes to this {{ instance.is_request ? 'request' : 'campaign' }}</div>
				</div>
			</div>

			<div v-if="error" class="v2rt-empty">
				<div class="v2rt-empty__icon v2rt-empty__icon--error">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
				</div>
				<p class="v2rt-empty__text">{{ error }}</p>
			</div>

			<div v-else-if="history.length" class="v2rt-history-wrap">
				<table class="v2rt-history">
					<thead>
						<tr>
							<th style="width: 18%">{{ $t('campaign.date') }}</th>
							<th>{{ $t('campaign.old_value') }}</th>
							<th>{{ $t('campaign.new_value') }}</th>
							<th style="width: 22%">{{ $t('campaign.login') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in history" :key="item.date">
							<td class="v2rt-history__date">{{ formatDateTime(item.date) }}</td>
							<td>
								<span class="v2rt-history__old">
									<HistoryItem :item="item" :is-new-value="false" />
								</span>
							</td>
							<td>
								<span class="v2rt-history__new">
									<HistoryItem :item="item" :is-new-value="true" />
								</span>
							</td>
							<td class="v2rt-history__login">{{ userName(item) }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div v-else class="v2rt-empty">
				<div class="v2rt-empty__icon">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h18v18H3z"/><path d="M9 9h6v6H9z"/></svg>
				</div>
				<p class="v2rt-empty__text">{{ $t('campaign.history_not_found') }}</p>
			</div>
		</div>
	</section>
</template>


<script>
import OriginalTabHistory from '@/pages/request/review/tab-history.vue';
import HistoryItem from '@/components/creative/history-item';

export default {
	name: 'V2TabHistory',

	extends: OriginalTabHistory,

	components: {
		...OriginalTabHistory.components,
		HistoryItem,
	},
};
</script>


<style lang="sass" scoped>
@import './tab-shared'

.v2rt-history-wrap
	border: 1px solid rgba($border, 0.6)
	border-radius: 14px
	overflow: hidden

.v2rt-history
	width: 100%
	border-collapse: collapse
	font-size: 12px

	thead
		background: rgba($bg, 0.5)

	th
		padding: 11px 14px
		text-align: left
		font-size: 10px
		font-weight: 700
		text-transform: uppercase
		letter-spacing: 0.06em
		color: $muted
		white-space: nowrap

	td
		padding: 12px 14px
		border-top: 1px solid rgba($border, 0.5)
		vertical-align: middle
		color: $text

.v2rt-history__date
	font-family: $mono
	color: $muted
	white-space: nowrap

.v2rt-history__login
	font-family: $mono
	font-size: 11px
	color: $muted

.v2rt-history__old
	::v-deep
		font-family: $mono
		color: $red
		background: rgba($red, 0.07)
		padding: 2px 7px
		border-radius: 5px
		display: inline-block
		text-decoration: line-through

.v2rt-history__new
	::v-deep
		font-family: $mono
		color: $green
		background: rgba($green, 0.07)
		padding: 2px 7px
		border-radius: 5px
		display: inline-block

// ─── Empty ───
.v2rt-empty
	padding: 40px 20px
	text-align: center

.v2rt-empty__icon
	width: 56px
	height: 56px
	border-radius: 14px
	background: rgba($bg, 0.7)
	color: $muted
	display: flex
	align-items: center
	justify-content: center
	margin: 0 auto 12px

	svg
		width: 24px
		height: 24px

	&--error
		background: rgba($red, 0.1)
		color: $red

.v2rt-empty__text
	font-size: 13px
	color: $muted
</style>
